import { LitElement } from './-global.min.js'

export class HHProductMedia extends LitElement {
  static properties = {
    id: {
      type: String,
      reflect: true,
      attribute: 'id'
    },
  }

  constructor() {
    super()
    this.id = ''
  }

  firstUpdated() {
    this.initializeCarousel()

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', () => this.initializeCarousel())
    }
  }

  initializeCarousel() {
    const thumnailCarousel = new Swiper(`.js-thumbnail-carousel-${this.id}`, {
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 10,
      // mouseDragging: true,
      loop: true,
      navigation: {
        nextEl: `.js-thumbnail-wrapper-${this.id} .swiper-button-next`,
        prevEl: `.js-thumbnail-wrapper-${this.id} .swiper-button-prev`,
      },
      keyboard: {
        enabled: true
      },
      mousewheel: {
        forceToAxis: true
      },
      watchSlidesProgress: true,
      allowTouchMove: true,
      breakpoints: {
        990: {
          slidesPerView: 5,
        }
      }
    })

    const mediaCarousel = new Swiper(`.js-media-carousel-${this.id} .swiper`, {
      slidesPerView: 1,
      lazy: true,
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: `.js-media-carousel-${this.id} .swiper-button-next`,
        prevEl: `.js-media-carousel-${this.id} .swiper-button-prev`,
      },
      // effect: 'creative',
      mouseDragging: true,
      mousewheel: {
        forceToAxis: true
      },
      thumbs: {
        swiper: thumnailCarousel,
      },
      keyboard: {
        enabled: true
      },
      breakpoints: {
        990: {
          spaceBetween: 0,
        }
      },
      on: {
        slideChange: function () {
          // Pause all videos when changing slides
          const videos = this.el.querySelectorAll(`hh-media-chrome-video`);
          for (const video of videos) {
            video.pause()
          }
          // Play video on active slide
          const activeIndex = this.activeIndex;
          const activeSlide = this.el.querySelectorAll('.swiper-slide')[activeIndex];
          if (!activeSlide) return;
          const activeSlideVideo = activeSlide.querySelector('hh-media-chrome-video');
          if (!activeSlideVideo) return;
          activeSlideVideo.play();
        },
      }
    })

    const thumbnailCards = thumnailCarousel.slidesEl.querySelectorAll('.swiper-slide')
    thumbnailCards.forEach((slide) => {
      slide.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          mediaCarousel.slideTo(slide.dataset.position - 1)
        }
      })
    })

    // Add modal carousel initialization
    const modalThumbnailCarousel = new Swiper(`.js-modal-thumbnail-carousel-${this.id}`, {
      slidesPerView: "auto",
      spaceBetween: 8,
      mouseDragging: true,
      keyboard: {
        enabled: true
      },
      mousewheel: {
        forceToAxis: true
      }
    })

    const modalMediaCarousel = new Swiper(`.js-modal-media-carousel-${this.id}`, {
      slidesPerView: 1,
      lazy: true,
      mouseDragging: true,
      spaceBetween: 10,
      speed: 0,
      navigation: {
        nextEl: `.js-modal-media-carousel-${this.id} .swiper-button-next`,
        prevEl: `.js-modal-media-carousel-${this.id} .swiper-button-prev`,
      },
      mousewheel: {
        forceToAxis: true
      },
      thumbs: {
        swiper: modalThumbnailCarousel,
      },
      keyboard: {
        enabled: true
      }
    })

    const modalThumbnailCards = modalThumbnailCarousel.slidesEl.querySelectorAll('.swiper-slide')
    modalThumbnailCards.forEach((slide) => {
      slide.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          modalMediaCarousel.slideTo(slide.dataset.position - 1)
        }
      })
    })
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('hh-product-media', HHProductMedia)
